// eslint-disable-next-line import/no-unresolved
import Frente from '../../../../static/autos/Frente.jpg';
import izquierdo from '../../../../static/autos/LadoIzquierdo.jpg';
import Camara from '../../../../static/autos/Camara.jpg';

export const cardEmpty = {
  item: '1',
  key: 1,
  parte: 'Extra',
  image: Camara,
  check: false
};

export const cards = [
  {
    item: '1',
    key: 1,
    parte: 'Frente',
    image: Frente,
    check: false
  },
  {
    item: '2',
    key: 2,
    parte: 'Foto Panorámica del Sector del Daño',
    image: izquierdo,
    check: false
  },
  {
    item: '3',
    key: 3,
    image: Frente,
    parte: 'Foto Específica del Daño',
    check: false
  }
];

export const cardsGeneral = [
  {
    item: '1',
    key: 1,
    parte: 'Frente',
    image: Frente,
    check: false
  },
  {
    item: '2',
    key: 2,
    parte: 'Foto Panorámica del Sector del Daño',
    image: Frente,
    check: false
  },
  {
    item: '3',
    key: 3,
    image: izquierdo,
    parte: 'Foto Específica del Daño',
    check: false
  }
];

export const cardsPatrimoniales = [
  {
    item: '1',
    key: 1,
    parte: 'Fotografía del Daño',
    image: Camara,
    check: false
  },
  {
    item: '2',
    key: 2,
    parte: 'Fotografía del Daño',
    image: Camara,
    check: false
  }
];
